import { inject } from '@angular/core';
import { AuthService } from '../data-access/auth.service';
import { map } from 'rxjs';
import { Router } from '@angular/router';
import {environment} from "../../../environments/environment";

export const LoginResolver = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.token$.pipe(
    map((token) => {
      if (token && environment.__auth_email === null) {
        router.navigate(['/dashboard']);
      }
      return true;
    })
  );
};
